import ninegrid from "../index.js";
import { ngCellEx } from "./_ngCell.js";

class ngImg extends ngCellEx
{
	#target;
	//#src;
	
	constructor() {
		super();
		this.applyBaseStyle();
	}

	connectedCallback() {
		const border		= this.getAttribute("border") || "unset";
		const borderRadius	= this.getAttribute("border-radius") || "unset";
		const link			= this.getAttribute("link");
		
		var attr = [];
		for (var i = 0; i < this.attributes.length; i++) {
			if (["alt","width","height"].includes(this.attributes[i].name)) attr.push(`${this.attributes[i].name}="${this.attributes[i].value}"`);
		}
		
		this.shadowRoot.innerHTML = `
			<style>
				img {
					border: ${border};
					border-radius: ${borderRadius};
					cursor: ${link == "true"? "pointer" : "unset"};
				}
				img:hover {
					filter: ${link == "true"? "brightness(80%)" : "unset"};
				}
			</style>

			<div class="ng-wrap">
				<img ${attr.join(" ")} class="renderer" />
			</div>
		`;

		/** img,div class="renderer" 일때 ngCell에서 link로 연결 */
		
		super.connectedCallback();
		
		this.#target = this.shadowRoot.querySelector("img");
	};
	
	dataRefresh = (v) => {

		var src = this.getAttribute("src");// || this.cell.getAttribute("src");
		
		var exprSrc = (src) ? this.getExprValue(src, this.cell.closest("tr").data, this.cell.dataset.row) : "";
		
		src = exprSrc || this.getDisplayText();
		this.#target.src = src;
		
		src ? $(this.#target).show() : $(this.#target).hide();

		if (!v) this.reset();
	};
	
	r = (owner, cell) => {

		const src = this.getAttribute("icon-src") || cell.getAttribute("icon-src");
		var exprSrc = (src) ? this.getExprValue(src, cell.closest("tr").data, cell.dataset.row) : "";
		
		this.#target.src = exprSrc || this.value;
	};
}

class ngSvg extends ngCellEx
{
	#target;
	#src;
	
	constructor() {
		super();
		this.applyBaseStyle();

		this.#src = this.getAttribute("src");
	}

	connectedCallback() {
		const border		= this.getAttribute("border") || "unset";
		const borderRadius	= this.getAttribute("border-radius") || "unset";
		const link			= this.getAttribute("link");
				
		this.shadowRoot.innerHTML = `
			<style>
				div {
					border: ${border};
					border-radius: ${borderRadius};
					cursor: ${link == "true"? "pointer" : "unset"};
				}
				div:hover {
					filter: ${link == "true"? "brightness(80%)" : "unset"};
				}
			</style>

			<div class="ng-wrap"></div>
		`;

		/** img,div class="renderer" 일때 ngCell에서 link로 연결 */
		
		super.connectedCallback();
		
		this.#target = this.shadowRoot.querySelector("div");
	};
	
	dataRefresh = (v) => {
		
		const src = this.getAttribute("src");// || this.cell.getAttribute("src");

		var exprSrc = (src) ? this.getExprValue(src, this.cell.closest("tr").data, this.cell.dataset.row) : "";

		this.#target.innerHTML = exprSrc || this.getDisplayText();
		
		if (!v) this.reset();
	};
	
	
	r = (owner, cell) => {

		const src = this.getAttribute("icon-src") || cell.getAttribute("icon-src");
		var exprSrc = (src) ? this.getExprValue(src, cell.closest("tr").data, cell.dataset.row) : "";
		
		this.#target.innerHTML = exprSrc || this.value;
	};
}

if (!customElements.get('ng-img')) {
	customElements.define("ng-img", ngImg);
}

if (!customElements.get('ng-svg')) {
	customElements.define("ng-svg", ngSvg);
}
